import React from 'react';
import PropTypes from 'prop-types';
import sanitizeHtml from 'sanitize-html';
import { get, without } from 'lodash';
import styles from './ArticleBody.module.styl';
import BodyPhoto from './BodyPhoto';

const BodyElement = ({
  type,
  subtype,
  content,
  ...rest
}) => {
  switch (type) {
    case 'raw_html':
    case 'text': {
      const sanitized = sanitizeHtml(
        content,
        {
          allowedTags: without(sanitizeHtml.defaults.allowedTags, 'p'),
          allowedAttributes: {
            ...sanitizeHtml.defaults.allowedAttributes,
            iframe: ['src', 'width', 'height'],
          },
        },
      );
      return (
        // eslint-disable-next-line react/no-danger
        <p className={styles.paragraph} dangerouslySetInnerHTML={{ __html: sanitized }} />
      );
    }
    case 'image': {
      const credit = [
        get(rest, 'credits.by[0].name'),
        get(rest, 'credits.by[0].affiliation'),
      ].filter((a) => a).join('/');
      return <BodyPhoto url={rest.url} caption={rest.caption} credit={credit} />;
    }
    case 'header': {
      const sanitized = sanitizeHtml(
        content,
        {
          allowedTags: without(sanitizeHtml.defaults.allowedTags, 'p'),
        },
      );
      switch (get(rest, 'level', 3)) {
        case 1:
        case 2:
          // eslint-disable-next-line react/no-danger
          return <h2 className={styles.heading} dangerouslySetInnerHTML={{ __html: sanitized }} />;
        case 3:
          // eslint-disable-next-line react/no-danger
          return <h3 className={styles.heading} dangerouslySetInnerHTML={{ __html: sanitized }} />;
        case 4:
        default:
          // eslint-disable-next-line react/no-danger
          return <h4 className={styles.heading} dangerouslySetInnerHTML={{ __html: sanitized }} />;
      }
    }
    default: {
      if (process.env.NODE_ENV === 'development') {
        return (
          <React.Fragment>
            <h2>Unrecognized Element</h2>
            <pre>
              {JSON.stringify(
                {
                  type,
                  subtype,
                  content,
                  ...rest,
                },
                null,
                2,
              )}
            </pre>
          </React.Fragment>
        );
      }
      return null;
    }
  }
};

BodyElement.propTypes = {
  type: PropTypes.string.isRequired,
  subtype: PropTypes.string,
  content: PropTypes.string,
};

export default BodyElement;
